import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import APICom from "../../../utils/helpers/APICom";
import ConfirmationModal from "../../Controls/ConfirmationModal";
import CommonFunctions from "../../../utils/helpers/CommonFunctions";

const RunRouteSuggestion = (props) => {
    const { AffiliateData,GlobalASCSData } = useSelector((store) => store.combinedata);
    const [showRouteSuggestionAlert, setRouteSuggestionAlert] = useState(false);
    const [RouteSuggestionAlertObj, setRouteSuggestionAlertObj] = useState({ alertTitle: '', alertMsg: '', displayFooter: true });
    const { loginData } = useSelector((store) => store.login);
    const [confirmationModalObj, setConfirmationModalObj] = useState({show: false, title:'Auto Routing', body:'Are you Sure you want to Pause Auto-Routing?', btnCanceText: 'No',btnOkText: 'Yes'});
 
    useEffect(() => {
        async function fetchData(){
        if (props.GridRowData === null || props.GridRowData.length <= 0) {
            setRouteSuggestionAlertObj({ ...RouteSuggestionAlertObj, alertTitle: 'Route-Suggestion', alertMsg: 'No request selected to perform Action.' , displayFooter: true});
            setRouteSuggestionAlert(true);
        }
        else {
            let result = await CommonFunctions.checkAutoRouting(props.selectedAffiliates, props.selectedDate, AffiliateData);
            if(result){
                setConfirmationModalObj((prevState) => ({...prevState, show:true, title:'Auto Routing', body:'Are you Sure you want to Pause Auto-Routing?', btnCanceText: 'No', btnOkText: 'Yes'}));
            }else{
                await RouteSuggestionActions();
            }
        }

    }
            fetchData();
    }, []);

    const RouteSuggestionActions = async() =>{
        try{

        
            const selectedGridData = props.GridRowData
            const affID = selectedGridData[0].iSRATSPID;
           

            if (props.showRouteSuggestionActionCreate) {
                BuildRouteSuggestion(selectedGridData, affID);
            }
        }
        catch(err){console.log(err);}
    }
    

    const BuildRouteSuggestion = async (selectedGridData, iAffiliateID) => {
        props.disbaleButton(true);
        let ids = null;
        let callBackURL = "";
        ids = GetServiceNScheduleIDsForWillMRM_New(selectedGridData, true);
        const pickupDateTime = selectedGridData[0].PickupDateTime;
        if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
            const jsonArray = GlobalASCSData;
            const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
            callBackURL = URL.value + '/WMRMSCommonAPI/SendMessageToWMRMS';
        }
        let Data = {
            "Trips": JSON.stringify(ids[2]),
            "iAffiliateID" : iAffiliateID,
            "dtPickupDateTime" : pickupDateTime,
            "iCreatedByAppId":26,
            "iCreatedByUID":loginData.iUserID,
            "call_back_url":callBackURL,
            "UpdateReason": '13'
        }
        setRouteSuggestionAlertObj({ ...RouteSuggestionAlertObj, alertTitle: 'Route Suggestion In Progress', alertMsg: 'Please Wait...' , displayFooter: false});
        setRouteSuggestionAlert(true);
        props.disbaleButton(true);
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/BuildManifestDispatch", "post", { "Content-Type": "application/json" }, Data, null);
        let result = response.data;
        if (result.run_id > 0) {
            setRouteSuggestionAlertObj({ ...RouteSuggestionAlertObj, alertTitle: 'Route Suggestion Started', alertMsg: 'Route Suggestion is being performed...' , displayFooter: false});
            setRouteSuggestionAlert(true);
            props.disbaleButton(true);
        }
        else if (result.error_message !== null && result.error_message !== "") {
            setRouteSuggestionAlertObj({ ...RouteSuggestionAlertObj, alertTitle: 'Route-Suggestion', alertMsg: result.error_message , displayFooter: true});
            setRouteSuggestionAlert(true);
            props.disbaleButton(false);
            setConfirmationModalObj((prevState) => ({...prevState, show:false}));
            handleRouteAlertClose();
        }
        else {
            setRouteSuggestionAlertObj({ ...RouteSuggestionAlertObj, alertTitle: 'Route-Suggestion', alertMsg: 'Something went wrong !!!' , displayFooter: true});
            setRouteSuggestionAlert(true);
            props.disbaleButton(false);
            setConfirmationModalObj((prevState) => ({...prevState, show:false}));
            handleRouteAlertClose();

        }
    }

    function GetServiceNScheduleIDsForWillMRM_New(array, bwillCallReqs) {
        var bwillCallReqsLocal = false;
        try {
            bwillCallReqsLocal = bwillCallReqs;
        } catch (Error) { }
        var result = Array();
        var service_ids = "";
        var schedule_ids = "";
        var trips = [];
        //var smaIDs = "";
        for (var i = 0; i < array.length; i++) {
                if ((array[i].bIsSchedule == "1")) {
                    schedule_ids += array[i].iScheduleID + ",";
                    trips.push({
                        "iScheduleID": array[i].iScheduleID,
                        "dtPickupDateTime": array[i]["PickupDateTime"],
                        "iRefID": array[i]["ConfirmationNo"]
                    });
                }
                else {
                    service_ids += array[i].ServiceID + ",";
                    trips.push({
                        "iServiceID": array[i].ServiceID,
                        "dtPickupDateTime": array[i]["PickupDateTime"],
                        "iRefID": array[i]["ConfirmationNo"]
                    });
                }
        }
        try {
            if ((service_ids != "") && (service_ids[service_ids.length - 1] == ','))
                service_ids = service_ids.substring(0, (service_ids.length - 1));
    
            if ((schedule_ids != "") && (schedule_ids[schedule_ids.length - 1] == ','))
                schedule_ids = schedule_ids.substring(0, (schedule_ids.length - 1));
        } catch (Error) { }
        result.push(service_ids);
        result.push(schedule_ids);
        result.push(trips);
        return result;
    }

    const handleRouteAlertClose = () => {
        setRouteSuggestionAlert(false);
        UnMountUnRouteComponent();
    }

    const UnMountUnRouteComponent = () => {
        if (props.showRouteActionCreate) {
            props.setUnRouteActionCreate(false);
        }
    }

    const handleConfirmationModalOk = () =>{
        CommonFunctions.SaveRBSStatus(1, props.selectedDate, props.selectedAffiliates, loginData.iUserID);
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        RouteSuggestionActions();
    }

    const handleConfirmationModalCancel = () =>{
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        props.setRouteSuggestionActionCreate(false)
    }
    
    const handleConfirmationModalClose = () => {
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
        props.setRouteSuggestionActionCreate(false)
    }

    return (
        <>
            {showRouteSuggestionAlert && <Modal centered keyboard={false} show={showRouteSuggestionAlert} backdrop="static" animation={true} onHide={handleRouteAlertClose} >
                <Modal.Header>
                    <Modal.Title>{RouteSuggestionAlertObj.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>{RouteSuggestionAlertObj.alertMsg}</b></Modal.Body>
                {RouteSuggestionAlertObj.displayFooter?
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleRouteAlertClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                :""}
            </Modal>}

            <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
            onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalCancel} onClose={handleConfirmationModalClose} btnCanceText={confirmationModalObj.btnCanceText}
            btnOkText={confirmationModalObj.btnOkText} ShowCancelButton="true" />
        </>
    );

};

export default RunRouteSuggestion;